import VideoViewCountTable from "./page/VideoViewCountTable";

const VideoViewCount: React.FC = () => {
  return(
    <>
  <VideoViewCountTable/>
  </>
  )
};
export default VideoViewCount;
